import {Brick, registerBrick} from 'olympe';
// eslint-disable-next-line no-unused-vars
import {TimeoutMap} from '@olympeio/core';

/**
 * This brick set a value in a TimeoutMap
 */
export default class SetInTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {TimeoutMap} timeoutMap
     * @param {*} key
     * @param {*} value
     * @param {function()} forwardEvent
     * @param {function(TimeoutMap)} setTimeoutMap
     */
    update($, [timeoutMap, key, value], [forwardEvent, setTimeoutMap]) {
        timeoutMap.set(key, value);
        setTimeoutMap(timeoutMap);
        forwardEvent();
    }
}

registerBrick('0192e322ae2c14289a45', SetInTimeoutMap);
